import z from 'zod';
import chalk from 'chalk';
import type { TUIElement } from './elements';
import { UIElementsSchemaWithChildren } from './elements';

export const UIDefinitionPageSchema = z.object({
  type: z.string(),
  number: z.number(),
  name: z.string(),
  stateName: z.string(),
  elements: z.array(UIElementsSchemaWithChildren),
  plugins: z.array(z.any()).optional(),
});

export type TUIDefinitionPage = Omit<z.infer<typeof UIDefinitionPageSchema>, 'elements'> & {
  elements: TUIElement[];
};

const getValueAtPath = (obj: any, path: string) => {
  const pathParts = path.split('.').map(part => {
    // Convert numeric strings to numbers for array indices
    return /^\d+$/.test(part) ? Number(part) : part;
  });

  let value = obj;

  for (const key of pathParts) {
    if (value === undefined || value === null) return undefined;

    value = value[key];
  }

  return value;
};

export const assertUIDefinitionValid = (definition: TUIDefinitionPage[]) => {
  try {
    const result = z.array(UIDefinitionPageSchema).parse(definition);

    return result;
  } catch (error) {
    if (error instanceof z.ZodError) {
      console.error(chalk.bold.red('UI Definition Validation Errors:'));
      error.issues.forEach(err => {
        console.error(chalk.red(`Message: ${err.message}`));
        console.log(
          chalk.red('Invalid value:'),
          chalk.green(getValueAtPath(definition, err.path.join('.'))),
        );
        console.error(chalk.red(`At path: ${err.path.join('.')}`));

        if (err.code === 'invalid_union') {
          console.error(chalk.red.bold('Union validation failed'));
        }
      });
    }

    throw new Error(`Validation failed: ${(error as z.ZodError).message}`);
  }
};
